var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { inject, observer } from 'mobx-react';
import { Checkbox, FormControlLabel, Stack, FormLabel } from '@mui/material';
var PhotoSettingsEditor = /** @class */ (function (_super) {
    __extends(PhotoSettingsEditor, _super);
    function PhotoSettingsEditor(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {};
        return _this;
    }
    Object.defineProperty(PhotoSettingsEditor.prototype, "render", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            var _a;
            var caseType = (_a = this.props.caseTypesStore) === null || _a === void 0 ? void 0 : _a.currentCaseType;
            return (_jsxs(Stack, __assign({ direction: "column", spacing: 2 }, { children: [_jsx(FormLabel, { children: _jsx("h4", { children: "myClaim photos settings" }, void 0) }, void 0), _jsx(FormControlLabel, { label: "Print date/time at photos before uploading to myClaim", sx: { whiteSpace: 'nowrap' }, control: _jsx(Checkbox, { color: "primary", checked: caseType === null || caseType === void 0 ? void 0 : caseType.printDateInPhotoBeforeUpload, onChange: function (e) { return _this.enablePrintDateTimeBeforeUploadToMyClaim(e); } }, void 0) }, void 0), _jsx(FormControlLabel, { label: "Print geolocation at photos before uploading to myClaim", sx: { whiteSpace: 'nowrap' }, control: _jsx(Checkbox, { color: "primary", checked: caseType === null || caseType === void 0 ? void 0 : caseType.printGpsInPhotoBeforeUpload, onChange: function (e) { return _this.enablePrintGpsBeforeUploadToMyClaim(e); } }, void 0) }, void 0)] }), void 0));
        }
    });
    Object.defineProperty(PhotoSettingsEditor.prototype, "enablePrintDateTimeBeforeUploadToMyClaim", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (e) {
            var _a, _b;
            var caseType = (_a = this.props.caseTypesStore) === null || _a === void 0 ? void 0 : _a.currentCaseType;
            if (caseType) {
                var updatedCaseType = __assign(__assign({}, caseType), { printDateInPhotoBeforeUpload: e.target.checked });
                (_b = this.props.caseTypesStore) === null || _b === void 0 ? void 0 : _b.updateCaseType(updatedCaseType);
            }
        }
    });
    Object.defineProperty(PhotoSettingsEditor.prototype, "enablePrintGpsBeforeUploadToMyClaim", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (e) {
            var _a, _b;
            var caseType = (_a = this.props.caseTypesStore) === null || _a === void 0 ? void 0 : _a.currentCaseType;
            if (caseType) {
                var updatedCaseType = __assign(__assign({}, caseType), { printGpsInPhotoBeforeUpload: e.target.checked });
                (_b = this.props.caseTypesStore) === null || _b === void 0 ? void 0 : _b.updateCaseType(updatedCaseType);
            }
        }
    });
    PhotoSettingsEditor = __decorate([
        inject('caseTypesStore'),
        inject('languageStore'),
        observer
    ], PhotoSettingsEditor);
    return PhotoSettingsEditor;
}(React.Component));
export default PhotoSettingsEditor;
